import CircularProgress from 'material-ui/CircularProgress';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { Entities, fetchById, getUpdatedEntity, patch, save, update } from 'src/common/index';
import ErrorMessage from 'src/components/misc/error-message';
import { formValueSelector } from 'redux-form';
import NotificationAdministrationAddForm from 'src/components/superadmin/notifications/components/notification-administration-add-form';
import NotificationAdministrationTestMailModal from 'src/components/superadmin/notifications/components/notification-administration-test-mail-modal';

class NotificationAdministrationModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
        };
    }

    componentWillMount() {
        const { isCreate, id } = this.props;
        if (!isCreate) this.props.fetchById(id, Entities.RECENT_OPERATOR_NOTIFICATIONS);
        else this.setState({ startedFetching: true });
    }

    componentWillReceiveProps(nextProps) {
        const { notification } = nextProps;

        if (!this.state.startedFetching && notification.isFetching) this.setState({ startedFetching: true });
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { isCreate, t, notification, operatorNotificationEdit } = this.props;
        const finishFetching = this.state.startedFetching && !notification.isFetching;
        if (finishFetching) {
            if (notification.error) return <ErrorMessage object={module} />;
            else {
                let initialValues;

                if (!isCreate)
                    initialValues = {
                        id: notification.content.id,
                        title: notification.content.title,
                        text: notification.content.text,
                        type: notification.content.type,
                    };
                else {
                    initialValues = {};
                }
                return (
                    <NotificationAdministrationAddForm
                        t={t}
                        initialValues={Object.keys(initialValues).length > 0 ? initialValues : operatorNotificationEdit}
                        onSubmit={this.handleSubmit}
                        isCreate={isCreate}
                        ref={ref => (this.childForm = ref)}
                    />
                );
            }
        } else return <CircularProgress />;
    }

    openTestEmailModal(operatorNotification) {
        this.props.openModal({
            component: NotificationAdministrationTestMailModal,
            componentProps: {
                operatorNotification,
                t: this.props.t,
                close: this.props.handleClose,
                parentOpenModal: this.props.openModal,
            },
            title: this.props.t('operator_notifications.modal.title_test_mail'),
            noButtons: true,
        });
    }

    handleSubmit(data) {
        const { isCreate, handleClose } = this.props;
        if (data.type === 'NEWSLETTER' && isCreate) {
            this.openTestEmailModal(data);
        } else {
            if (!isCreate) this.props.update(data, Entities.RECENT_OPERATOR_NOTIFICATIONS);
            else this.props.save(data, Entities.RECENT_OPERATOR_NOTIFICATIONS);
            handleClose();
        }
    }
}

const selector = formValueSelector('moduleEditForm');

const mapStateToProps = state => {
    return {
        notification: getUpdatedEntity(state, Entities.RECENT_OPERATOR_NOTIFICATIONS),
        selectedType: selector(state, 'type'),
    };
};

export default connect(
    mapStateToProps,
    {
        fetchById,
        patch,
        save,
        update,
    },
    null,
    { withRef: true },
)(NotificationAdministrationModal);
